/**
 * Info Component implemented with Material UI
 * 
 * This component provides a tooltip-style information display for the application.
 */
import React from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip, TooltipProps } from '@mui/material';
import { MuiStatic } from 'components/molecules/BubbleContent';
import { InfoProps } from 'types/components/atoms';

// Interface for the styled tooltip component props
interface StyledTooltipProps extends Omit<TooltipProps, 'classes' | 'title'> {
  className?: string;
  title?: React.ReactNode;
}

/**
 * Info component
 * 
 * @param props - Component props
 * @returns A tooltip-style info component
 */
const Info: React.FC<InfoProps> = ({
  arrow = false,
  placement = 'top',
  enterDelay = 100,
  leaveDelay = 0,
  ...props
}) => {
  return (
    <StyledTooltip 
      arrow={arrow}
      placement={placement}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      {...props}
    >
      {MuiStatic && <MuiStatic />}
    </StyledTooltip>
  );
};

// Styled components using MUI styled API
const StyledTooltip = styled(
  ({ className, ...props }: StyledTooltipProps) => (
    <Tooltip {...props as TooltipProps} classes={{ tooltip: className }} />
  )
)(({ theme }) => ({
  backgroundColor: 'var(--app-dark-gray)',
  color: '#fff',
  opacity: 0.8,
  zIndex: 10,
  padding: '4px 8px',
}));

export type { InfoProps };
export default Info;
